import {assert} from '../utils'
import axios from 'axios'

export function commonFetch (ax) {
  return (context, params) => {
    let entity
    let callback
    if (typeof params === 'string') {
      entity = params
    } else {
      assert(typeof params.entity === 'string')
      assert(typeof params.callback === 'function')
      entity = params.entity
      callback = params.callback
    }
    context.commit('INC_LOADER', null, {root: true})
    return ax.get('/' + entity.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`))
      .then(response => {
        let data = callback ? callback(response.data) : response.data
        context.commit('SET_DATA', {entity: entity, data: data})
      })
      .finally(() => {
        // TODO: Simplify loaders
        context.commit('DEC_LOADER', null, {root: true})
      })
  }
}

const isDevMode = process.env.NODE_ENV === 'development'

const scheme = isDevMode ? 'http' : 'https'
const port = isDevMode ? '8088' : '8089'

export const backendUri = `${scheme}://${window.location.hostname}:${port}`
// export const backendUri = 'https://demo.bridge8.tech:8089'

export const apiAx = axios.create({
  baseURL: `${backendUri}/api`,
  headers: { 'Let-Me-In': 'PathView' },
  timeout: 180000,
  paramsSerializer: function (params) {
    return Object.keys(params).map(key => {
      const param = params[key]
      return `${key}=${Array.isArray(param) ? param.join(',') : param}`
    }).join('&')
  }
})



// WEBPACK FOOTER //
// ./src/store/common.js